<clr-progress-bar
    id="cluster-polling-progress-bar"
    [clrValue]="progress"
    [clrMax]="maxProgress"
    [clrLabeled]="labeled"
></clr-progress-bar>
